// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.102.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aiiif-fullscreen-button{
    position: absolute;
    top: 5px;
    right: 0;
    width: 45px;
    z-index: 2;
}

.aiiif-embedded .aiiif-fullscreen-button{
    width: 90px;
}


.aiiif-fullscreen-button > button {
    border: none;
    background-color: transparent;
    font-size: 1.6rem;
    cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/topBar/fullscreen.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,YAAY;IACZ,6BAA6B;IAC7B,iBAAiB;IACjB,eAAe;AACnB","sourcesContent":[".aiiif-fullscreen-button{\n    position: absolute;\n    top: 5px;\n    right: 0;\n    width: 45px;\n    z-index: 2;\n}\n\n.aiiif-embedded .aiiif-fullscreen-button{\n    width: 90px;\n}\n\n\n.aiiif-fullscreen-button > button {\n    border: none;\n    background-color: transparent;\n    font-size: 1.6rem;\n    cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
